import React, {useState, useEffect, useContext} from 'react';
import Preloader from '../../components/Preloader/Preloader';
import SearchCardView from './SearchCardView';
import SearchTableView from './SearchTableView';
import { Offcanvas } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import OffcanvasTemplate from './OffcanvasTemplate';
import axios from 'axios';
import { books_category, bookCategory, bookClassification } from '../../ProData';
import AutoComplete from '../../components/AutoComplete';
import { useSnackbar } from 'notistack';
import BookCategoryCarosel from '../BookCategoryCarosel';
import {Helmet} from 'react-helmet-async';
import { fetchAuthSession } from 'aws-amplify/auth';

const config = require('../../config.json');

export default function BooksSearch() {
    const { validateLogin, loggedUser } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [searchResult, setSearchResult]=useState([]);
    const [searchCounter, setSearchCounter] = useState(0);
    const [searchValue, setSearchValue]= useState('');
    const [searchTopic, setSearchTopic]=useState('AccessionNo');
    const [show, setShow] = useState(false);
    const [loaded, setLoaded] = useState(true);
    const [selectedBook, setSelectedBook] = useState({Accession_No:"", Book_Author:"",bookCategory:"NA",
      Book_Classification_No: "", bookEdition: "NA", bookPages: "", bookPrice: "0", Publishing_Year: "",
      Book_Publisher:"", Book_Scope:"", Book_Status:"", Book_Title:"", registeredOn:"", autoGenerate:false,
      authorMark:'',bookAbstract:'',bookKeywords:'',bookCopies:'',bookPublisherLocation:'',bookSubTitle:'',
      bookDimension:'',isbn:''});
    const [tableView,setTableView] = useState(true);
    const [cardView, setCardView] = useState(false);
    const [dispMsg, setDispMsg] = useState('');
    const [searchCompleted, setSearchCompleted] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [userType, setUserType] = useState('');

      const [showScrollTop, setShowScrollTop] = useState(false);
  // Scroll to top handler
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowScrollTop(true);
    } else {
      setShowScrollTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

    const handleClose = () => setShow(false);
    const handleShow = (event, item) => {
      event.preventDefault();
      setSelectedBook(item);
      setShow(true);
    }
  
    useEffect(()=>{
      if(!loggedUser.isAuthenticated){
        validateLogin();
      }else{
        const temp=books_category.filter((item)=>item.categoryDisplay==="Yes");
        setCategoryList(temp);
      }
    },[loggedUser])
  
    const handleSearch=async(event)=>{
        event.preventDefault();
        try{
            //console.log("search value :", searchValue);
           // console.log("search topic :", searchTopic);
            if(searchValue.length===0){
              enqueueSnackbar('Search Value cannot be empty',{variant:'info'}); 
            //}else if(searchValue.length<=4){
            //enqueueSnackbar('Less Characters entered! Provide more characters to finetune your search.',{variant:'info'}); 
            }else{
              setLoaded(false);
              setDispMsg('');
              setSearchCompleted(false);
              setSearchResult([]);  
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            //const clientID="VJCollege";
            var keysearchValue="";
            if(searchTopic==="BookCategory"){
              keysearchValue=searchValue;
            }else{
              keysearchValue=searchValue.toUpperCase();
            }
            await axios.get(`${config.api.invokeUrl}/search/books?fetchKey=${keysearchValue}&fetchOption=${searchTopic}&clientID=${loggedUser.family_name}`,{
            //await axios.get(`${config.api.invokeURL}/vjlibrary/search/books?fetchKey=${keysearchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
              Authorization: idToken,
             'x-api-key':config.api.key
            }
          }).then(async(response) => {
            //console.log("response : ", response.data);
            setDispMsg(response.data.length+' - Books Found');
            const sortedResults = (response.data || []).slice().sort((a, b) => {
              const aAuthor = (a.Book_Author || a.bookAuthor || '')?.toString();
              const bAuthor = (b.Book_Author || b.bookAuthor || '')?.toString();
              const authorCmp = aAuthor.localeCompare(bAuthor, undefined, {numeric: true, sensitivity: 'base'});
              if (authorCmp !== 0) return authorCmp;
              const aTitle = (a.Book_Title || a.bookTitle || '')?.toString();
              const bTitle = (b.Book_Title || b.bookTitle || '')?.toString();
              const titleCmp = aTitle.localeCompare(bTitle, undefined, {numeric: true, sensitivity: 'base'});
              if (titleCmp !== 0) return titleCmp;
              const aAcc = (a.Accession_No || a.accessionNo || '')?.toString();
              const bAcc = (b.Accession_No || b.accessionNo || '')?.toString();
              return aAcc.localeCompare(bAcc, undefined, {numeric: true, sensitivity: 'base'});
            });
            setSearchResult(sortedResults);
            setSearchCounter(c => c + 1);
            enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'});
            setLoaded(true);
            setSearchCompleted(true);
        }).catch((error)=>{
          //console.log("error:", error);
          setLoaded(true);
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })}
        }catch(error){
            //console.log("error1:", error);
            setLoaded(true);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    }

    const handleTableView=(event)=>{
      event.preventDefault();
      setTableView(true)
      setCardView(false);
    }

    const handleCardView=(event)=>{
      event.preventDefault();
      setTableView(false);
      setCardView(true);
    }

    const processSelection=(ivalue)=>{
      //console.log("ivalue:", ivalue);
      if(ivalue){
      if(searchTopic==="BookCategory"){
        setSearchValue(ivalue.svalue);
      }else if(searchTopic==="BookClassification"){
        setSearchValue(ivalue.value);
      }else{
        setSearchValue(ivalue.name);
      }
    }else{
      setSearchValue(userType);
    }
    }

  return (
    <div>
    <Helmet>
      <title>Book Search - Inigo Library - Arul Kadal - Chennai</title>
      <meta name="description" content="Book Search - Inigo Library - Arul Kadal - Chennai" />
      <meta name="keywords" content="Book Search - Inigo Library - Arul Kadal - Chennai" /> 
    </Helmet>

        <Offcanvas show={show} onHide={handleClose} placement={['end']} scroll={true}	>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><i class="fa fa-id-card" aria-hidden="true"></i> {"  -   "}
              {selectedBook.Accession_No}</Offcanvas.Title>
          </Offcanvas.Header>
        <Offcanvas.Body>
          <OffcanvasTemplate selectedBook={selectedBook} />
        </Offcanvas.Body>
    </Offcanvas>
    {!loaded &&  <Preloader show={loaded ? false : true} /> }
    <div>
    <section className="search_section layout_padding" style={{background: 'linear-gradient(120deg, #e3f6fc 0%, #fafdff 100%)', minHeight: 320, padding: '32px 0'}}>
      <div className="container">
        <div className="heading_container text-center mb-4">
          <h2 style={{fontWeight: 700, color: '#063547', letterSpacing: 0.5, fontSize: '2.1rem', marginBottom: 8, textShadow: '0 2px 8px #e3f6fc'}}>
            Search your favourite <span style={{color: '#0bb6d7'}}>Book's & Article's</span>
          </h2>
          <p style={{color: '#555', fontSize: '1.08rem', marginBottom: 0}}>Find books by ID, title, author, or category. Enjoy a fast, modern search experience!</p>
        </div>
        <form action="#" className='card p-3 shadow-lg border-0' style={{borderRadius: 18, background: '#fff', maxWidth: 900, margin: '0 auto 24px auto'}}>
          <div className="row g-2 align-items-center">
            <div className="col-12 col-md-3">
              <select name="searchOption" id="bookSearch"
                className="form-select form-select-md rounded-3 shadow-sm"
                style={{fontSize: '1.05rem', padding: '8px 12px'}}
                value={searchTopic}
                onChange={event=>setSearchTopic(event.target.value)}>
                <option value="AccessionNo">Book ID</option>
                <option value="BookTitle">Book Title</option>
                <option value="BookAuthor">Author</option>
                {/*<option value="BookCategory">Category</option>*/}
                <option value="BookClassification">Classification</option>
              </select>
            </div>
            {searchTopic==="BookCategory" ? (
              <div className="col-12 col-md-6">
                <AutoComplete
                  data={bookCategory}
                  onSelect={country => processSelection(country)}
                />
              </div>
            ) :searchTopic==="BookClassification" ? (
              <div className="col-12 col-md-6 d-flex align-items-center">
                <select
                  className="form-select form-select-md rounded-3 shadow-sm w-100"
                  style={{fontSize: '1.05rem', padding: '8px 12px'}}
                  value={searchValue}
                  onChange={e => setSearchValue(e.target.value)}>
                  <option value="">Select Classification</option>
                  {bookClassification && bookClassification.map((bc, idx) => (
                    <option key={idx} value={(bc && (bc.value || bc.svalue || bc.name)) || bc}>
                      {(bc && (bc.svalue || bc.label || bc.name || bc.value)) || bc}
                    </option>
                  ))}
                </select>
              </div>
            ): (
              <div className="col-12 col-md-6">
                <input type="text" className="form-control rounded-3 shadow-sm" style={{fontSize: '1.05rem', padding: '8px 12px'}} placeholder="Enter your search..." onChange={event=>setSearchValue(event.target.value)}/>
              </div>
            )}
            <div className="col-12 col-md-3 text-center">
              <button type="submit" className='btn btn-primary w-100 py-2 rounded-3 shadow-sm' style={{fontWeight: 600, fontSize: '1.08rem', letterSpacing: 0.5, background: 'linear-gradient(90deg, #063547 60%, #0bb6d7 100%)', border: 'none'}} onClick={event=>handleSearch(event)}>
                <i className="fa fa-search me-2"></i>Search
              </button>
            </div>
          </div>
        </form>
      </div>
    {/* Scroll To Top Icon */}
    {showScrollTop && (
      <button
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '40px',
          right: '40px',
          zIndex: 9999,
          background: 'linear-gradient(135deg, #063547 60%, #7ee8fa 100%)',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
        }}
        aria-label="Scroll to top"
        title="Scroll to top"
      >
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </button>
    )}
    {searchCompleted && <div className="row ml-4"  >
    <div className="col-md-6 ">
    <h4>{dispMsg}</h4>
    </div>
          {searchResult.length>0?<div className="col-md-6 btn-group" style={{textAlign:"end", alignItems:"flex-end"}}>
            <div style={{marginLeft:"75%", display:"flex"}}>
          <a href="#" className= {tableView?'btn btn-success':'btn btn-default'}><i onClick={event=>handleTableView(event)} className="fa fa-table fa-lg" aria-hidden="true" style={{fontSize:"20px"}}></i></a>
          <a href="#" className= {cardView?'btn btn-success':'btn btn-default'}><i onClick={event=>handleCardView(event)} className="fa fa-id-card fa-lg" aria-hidden="true" style={{fontSize:"20px"}}></i></a>
          </div>
          </div>:null}
        </div>}

        {tableView?<SearchTableView searchResult={searchResult} setSearchResult={setSearchResult} handleShow={handleShow} searchCounter={searchCounter} />:null}
        {cardView? <SearchCardView searchResult={searchResult} handleShow={handleShow}/>:null}
        </section>
    </div>

    {loaded && <BookCategoryCarosel />}

    {/*<div className='container' style={{paddingTop:"50px"}}>
      <header className="section">
      {!loaded && <Preloader show={loaded ? false : true} />}
          <div className="search-book ">
              <form id="contact ">
                <div className='row' >
                   <div className="col-lg-12 col-md-12 col-sm-12 ">
                   <fieldset className='search-book-form d-inline-flex p-2'>
                   <Form.Select aria-label="Default select example" className=""
                  onChange={event=>setSearchTopic(event.target.value)}>
                  <option value="AccessionNo">Book ID</option>
                  <option value="BookTitle">Book Title</option>
                  <option value="BookAuthor">Author</option>
                  </Form.Select>
                      <input name="search-input" type="text" className="" id="search-input" placeholder="Enter the Search Input...." required 
                      onChange={event=>setSearchValue(event.target.value)} />
                     <button type="submit" id="form-submit" className="main-button" onClick={event=>handleSearch(event)}><i className="fa fa-search" aria-hidden="true"></i></button>
                 
                   </fieldset>
                  </div> 
                 
                </div>
              </form>
          </div>
        </header>
        <div className="row" style={{textAlign:"end", alignItems:"flex-end"}}>
          <div style={{padding:"5px"}} >
          <i onClick={event=>handleTableView(event)} className="fa fa-table p-2" aria-hidden="true" style={{fontSize:"25px"}}></i>
          
          <i onClick={event=>handleCardView(event)} className="fa fa-id-card p-2" aria-hidden="true" style={{fontSize:"25px"}}></i>
          </div>
        </div>
        <h4>{dispMsg}</h4>
        {tableView?<SearchTableView searchResult={searchResult} handleShow={handleShow}/>:null}
        {cardView? <SearchCardView searchResult={searchResult} handleShow={handleShow}/>:null}
    </div>*/}
    </div>
  )
}
